import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }

import DPricingCard from '@/components/services/dedicated/DPricingCard.vue';
import DProxiesPrice from '@/services/dproxies-price';
import PageHead from '@/components/shared/PageHead.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const head = {
  title: 'Dedicated proxies',
  subtitle: 'Proxies that are only used by you!',
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(PageHead, { head: head }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(DProxiesPrice), (card) => {
          return (_openBlock(), _createBlock(DPricingCard, {
            key: card.id,
            card: card
          }, null, 8, ["card"]))
        }), 128))
      ])
    ])
  ]))
}
}

})